<template>
  <el-affix :offset="0">
    <div class="header ">
      <div class="real">
        <!-- logo -->
        <div class="logo hidden-md-and-down" :class="{'logo-active':currentRoute.name=='Home'}">
          <router-link to="/"> {{globalData.appName}}</router-link>
        </div>
        <!-- 几个a标签 -->
        <div class="nav">
          <router-link :class="{active:route.name==currentRoute.name}" v-for="(route,index) in allRoutes" :to="route.path" :key="index">{{route.name}}</router-link>
        </div>
      </div>
    </div>
  </el-affix>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { RouteRecordNormalized, useRouter } from 'vue-router'
import { useLog } from '@/hooks'
import { useGlobal } from '@/hooks'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { globalData } = useGlobal()
    const { getRoutes, currentRoute } = useRouter()
    // 筛选出要在Header上显示的按钮(meta.hideInHeader=true的不显示)
    const allRoutes: Array<RouteRecordNormalized> = getRoutes().filter(
      (r) => !r.meta.hideInHeader
    )

    return {
      allRoutes,
      currentRoute,
      globalData,
    }
  },
})
</script>

<style lang="scss" scoped>
$header-heght: 61px;

.active {
  border-bottom: 3px solid $theme-color;
  color: black;
}
.logo-active {
  border-bottom: 3px solid $theme-color;
}
.header {
  background: 0;
  width: 100%;
  height: $header-heght;
  border-bottom: 1px solid lightgray;
  background: white;

  .real {
    justify-content: space-between;
    display: flex;
    margin: 0 auto;
    width: 1440px;

    @media screen and (max-width: 1450px) {
      width: 1024px;
    }
    @media screen and (max-width: 992px) {
      width: 760px;
    }
  }

  .logo {
    font-size: 1.9rem;
    // font-weight: bold;
    line-height: $header-heght;
    padding: 0 1rem;
    cursor: pointer;
    a {
      color: $theme-color;
      text-decoration: none;
    }
  }

  .nav {
    display: flex;

    a {
      display: block;
      width: 80px;
      text-align: center;
      line-height: $header-heght;
      // border: 1px solid green;
      text-decoration: none;
      color: $gray-font;
      cursor: pointer;
      transition: color 0.6s;

      &:hover {
        color: black;
      }
    }
  }
}
</style>